import { useState } from "react";
import { performanceEnabled, performanceReport, stopPerformanceCapture } from "@/lib/performanceDiagnostics";
import { usePerformanceMilestone } from "@/lib/usePerformanceMilestone";

export function PerformanceDiagnostics() {
  const [active, setActive] = useState(performanceEnabled);
  const [report, setReport] = useState("");
  usePerformanceMilestone("route_commit");
  if (!active) return null;
  return <aside className="performance-diagnostics" aria-label="Diagnóstico de desempenho">
    <details>
      <summary>Desempenho · captura nesta aba</summary>
      <p>Até 200 eventos locais, sem nomes nem leituras. Atualize o relatório após cada sequência curta; eventos descartados são contabilizados.</p>
      <p>Montagem de widgets não significa dados prontos. A captura separa configuração confirmada da primeira leitura atual; não certifica todos os gráficos nem cache frio.</p>
      <button type="button" onClick={() => setReport(JSON.stringify(performanceReport(), null, 2))}>Atualizar relatório</button>
      <button type="button" onClick={() => { stopPerformanceCapture(); setReport(""); setActive(false); }}>Encerrar e limpar</button>
      <textarea aria-label="Relatório de desempenho" value={report} readOnly rows={10} />
    </details>
  </aside>;
}
